import { Component } from 'san';
import * as echarts from 'echarts';
import * as _ from 'lodash';
type EChartsOption = echarts.EChartsOption;

export default class DashboardBar extends Component {
    myChart: echarts.ECharts;
    constructor(options: any) {
        super(options);
    }

    initData(): {
        types: string[];
        reverseTypes: string[];
        series: [];
        dataGroupByStatus: [];
        colors: [];
    } {
        return {
            types: [],
            reverseTypes: [],
            series: [],
            dataGroupByStatus: [],
            colors: [],
        };
    }

    inited() { }

    attached() {
        this.initChart();

        // 监听，若widget大小发生变化，chart resize
        const elem = document.getElementById(`chart-${this.data.get('type')}`);
        const resizeObserver = new ResizeObserver(() => {
            this.myChart.resize();
        });
        resizeObserver.observe(elem);
    }

    initChart() {
        const type = this.data.get('type');
        this.data.set('colors', ['#BCBCBC', '#F9C762', '#5473C3']);
        this.initChartData();
        const types = this.data.get('types');
        const items = _.compact(_.flatten(this.data.get('dataGroupByStatus')));
        const hasData = !!items.length;
        const chartDom = document.getElementById(`chart-${type}`);
        if (chartDom) {
            echarts.dispose(document.getElementById(`chart-${type}`));
        }
        const autoHeight = types.length * 25 > 200 ? types.length * 25 : 200;
        chartDom.style.height = autoHeight + 'px';
        this.myChart = echarts.init(chartDom);
        const option: EChartsOption = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                orient: 'vertical',
                top: 'center',
                right: '16',
                tooltip: {
                    show: true,
                    padding: 0,
                    formatter: (param) => {
                        const dataGroupByStatus = this.data.get('dataGroupByStatus');
                        const series = this.data.get('series');
                        const index = _.findIndex(series, { name: param.name });
                        const sum = _.sum(dataGroupByStatus[index]);
                        const color = this.data.get('colors')[index];
                        const formatterArr = [];
                        formatterArr.push(`<div style="margin: -1px; border: 1px solid ${color}; border-radius: 4px; padding: 10px 0px;">`);
                        formatterArr.push(`<div style="padding: 0 10px;padding-bottom: 4px; margin-bottom:4px; border-bottom: 1px solid ${color};"><div style="display: inline-block; width: 10px; height:10px; background-color: ${color}; border-radius: 50%; margin-right: 4px;"></div>${param.name}（ ${sum} ）</div>`)
                        formatterArr.push(`<div></div>`);
                        const length = this.data.get('reverseTypes').length;
                        _.forEach(this.data.get('reverseTypes'), (type, i) => {
                            formatterArr.push('<div style="padding: 0 10px; margin-bottom: 4px; display: flex; justify-content: space-between;"><span style="margin-right: 26px;">' + type + '</span><span style="font-weight:700">' + dataGroupByStatus[index][length - (+i) - 1] + '</span></div>')
                        });
                        formatterArr.push(`</div>`);
                        return formatterArr.join('');
                    },
                }
            },
            title: {
                text: type,
                left: '16',
                top: '4',
                textStyle: {
                    color: '#1A1A1A',
                    fontWeight: 'normal',
                    fontSize: '14',
                }
            },
            graphic: {
                type: 'text',
                left: 'center',
                top: 'center',
                style: {
                    text: !hasData ? "暂无数据" : "",
                    fill: "#c0c0c0",
                    fontSize: 16
                }
            },
            grid: {
                left: '10%',
                right: '10%',
                bottom: '3%',
                containLabel: true,
            },
            xAxis: {
                show: hasData,
                type: 'value',
                name: "单位（个）",
            },
            yAxis: {
                show: hasData,
                type: 'category',
                axisLabel: {
                    interval: 0
                },
                data: types,
            },
            series: hasData ? this.data.get('series') : [],
        };

        option && this.myChart.setOption(option);
    }

    initChartData() {
        const dataList = _.reverse(this.data.get('items'));
        const series = [];
        const keys = _.map(dataList[0].items, 'key');
        const sumValues = [];
        _.forEach(dataList, dataItem => {
            sumValues.push( _.sum(_.map(dataItem.items, 'value')));
        });
        const dataGroupByStatus = [];
        _.forEach(keys, (key, i) => {
            const data = [];
            _.forEach(dataList, (dataItem) => {
                const items = dataItem.items;
                const item = _.find(items, { key: key });
                data.push(item ? item.value : 0);
            });
            dataGroupByStatus.push(data);
            series.push({
                name: key,
                type: 'bar',
                stack: 'total',
                data: data,
                color: this.data.get('colors')[i],
                showBackground: true,
                backgroundStyle: {
                    color: 'white',
                    opacity: 0.1,
                }
            });
        });
        // // 新增加一个bar，用来展示总数，隐藏在堆叠柱下面
        // series.push({
        //     type: 'bar',
        //     stack: '',
        //     label: {
        //         position: 'right',
        //         color: '#1A1A1A',
        //         fontWeight: 'bolder',
        //         padding: [0, 8],
        //         show: true,
        //         formatter(val: any) {
        //             return val.value;
        //         },
        //     },
        //     data: sumValues,
        //     z: -1, 
        //     barGap: '-100%'
        // });
        this.data.set('types', _.map(dataList, 'type'));
        this.data.set('reverseTypes',_.reverse(_.map(dataList, 'type')));
        this.data.set('series', series);
        this.data.set('dataGroupByStatus', dataGroupByStatus);
    }
}
